<template>
  <button class="Button">
    <slot>A</slot>
  </button>
</template>
<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    onClick: {
      type: Function,
      required: false
    }
  }
};
</script>
<style scoped>
button {
  align-items: center;
  justify-content: center;
  width: 10em;
  height: 2em;
  margin: 0.5em;
  border-radius: 5px;
  background-color: green;
  font-size: 1em;
  color: white;
  border: none;
  outline: none;
}
</style>
